
import React, { useState } from "react";
const connect = require('react-redux/dist/react-redux.min.js').connect;
const ReduxStore = require('../redux/reduxStore.jsx.js');
const AjaxFunctions = require('../ajaxFunctions');
const SharedConstants = require('../../../../shared/sharedConstants');
const SharedModels = require('../../../../shared/sharedModels');
const Utils = require('../utils');
const CardModal= require('../components/cardModal.jsx.js').CardModal;
const PortfolioDiscussionTab = require('../components/portfolioDiscussionTab.jsx.js').PortfolioDiscussionTab;
const LoadingScreen = require('../components/loadingScreen.jsx.js').LoadingScreen;
const moment = require('moment');
const OverviewTab = require('./overviewTab.jsx.js').OverviewTab;

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Tooltip from '@material-ui/core/Tooltip';
import ZoomMtgEmbedded from '@zoomus/websdk/embedded';
const ToastAlert = require('../components/toastAlert');
import Toastr from 'toastr';
import EvidenceTab from '../components/evidenceTab';
import IncubatorAddCardTab from '../components/incubatorAddCardTab';
import { Card, Button, CardContent, Typography} from "@material-ui/core";
import ReactLinkify from "react-linkify";
import Bracket from "../components/bracket/bracket";
import {ConnectionsView} from '../connectionsView.jsx.js';
import {Mania} from '../components/mania/mania';
import {BracketSubmitDialog} from '../components/bracket/bracketSubmitDialog.jsx.js';
import {ManiaSubmitDialog} from '../components/mania/maniaSubmitDialog.jsx.js';
import {QuestionTab} from "./questionTab.jsx";
import {RulesTab} from "./rulesTab.jsx";
import {ArpahSubmissionTab} from "./arpahSubmissionTab.jsx";


let openSignInDialog = () => {
   let signInButton = document.getElementById('headerSignInButton')
   if(signInButton){
      signInButton.click();
   }
}

let tooltipTitle = (title) => {
   return (
      <React.Fragment>
         <div style={{ fontSize: SharedConstants.TooltipValue.FontSize, lineHeight: SharedConstants.TooltipValue.LineHeight }}>
            {title}
         </div>
      </React.Fragment>
   )
};

function ResourcesTab(props) {
   return (
      <Card>
         <CardContent>
           {props.resources &&
            <div>
            <Typography variant="h5" component="h2" color='primary' className='incubator-card-name' gutterBottom>
               {props.title || 'RESOURCES'}
            </Typography>
            <Typography color="textSecondary" gutterBottom component="p" style={{ whiteSpace: 'pre-wrap', marginBottom:'1em' }}>
               <ReactLinkify>
                  {props.resources}
               </ReactLinkify>
            </Typography>
            </div>}
            <Typography variant="h5" component="h2" color='primary' className='incubator-card-name' gutterBottom>
               HOW IT WORKS
            </Typography>
            <Typography color="textSecondary" gutterBottom component="p" style={{ whiteSpace: 'pre-wrap' }}>
               {props.instructions || SharedConstants.DefaultIncubatorInstructions}
            </Typography>
         </CardContent>
      </Card>
   );
}

function AboutTab(props) {
   return (
      <Card className={'about-tab'}>
         <CardContent>
            <Typography variant="h5" component="h2" color='primary' className='incubator-card-name' gutterBottom>
              {`About ${props.sponsorDisplayName}`}
            </Typography>
            <Typography color="textSecondary" gutterBottom component="p" style={{ whiteSpace: 'pre-wrap' }}>
               <ReactLinkify>
                  {props.sponsorBio}
               </ReactLinkify>
            </Typography>
         </CardContent>
      </Card>
   );
}

function GraphTab(props) {
   return (
      <Card>
         <CardContent>
            <ConnectionsView idPortfolio={props.portfolio.id} />
         </CardContent>
      </Card>
   );
}

let gettingPageData = false;

class PortfolioBase extends React.Component{
   constructor(props) {
      super(props);
      this.state = {
         value: '',
         idPortfolio: Utils.getParameterByName('idIncubator', window.location.href),
         isInitialized: false,
         key:0,
         showAddCategoryDialog: false,
         showSubmitManiaDialog: false,
         category: SharedConstants.BracketCategory.TopLeftBracket.id,
         selectedIDCard:null,
         selectedCardType:null,
         selectedCardReason: '',
         selectedCardTitle: '',

      }
   }

   componentDidMount() {
      this.getPageData();
   }

   componentDidUpdate(prevProps) {
      if (prevProps.location && this.props.location) {
         const lastState = prevProps.location.state || {};
         const currState = this.props.location.state || {};
         if (lastState.refresh != currState.refresh) {
            this.getPageData();
         }
      }
   }

   async getPageData() {
      if(gettingPageData){
         return;
      }
      else{
         gettingPageData = true;
      }
      Promise.all([
         AjaxFunctions.getUserPortfolios(),
         AjaxFunctions.getIncubatorById(this.state.idPortfolio),
         AjaxFunctions.getSynthesisTemplates(),
         AjaxFunctions.getIncubatorViewsByIdForUser(this.state.idPortfolio),
      ]).then((data) => {
         ReduxStore.store.dispatch(ReduxStore.PortfolioFunctions.setPortfolioList(data[0]));
         ReduxStore.store.dispatch(ReduxStore.PortfolioFunctions.setCurPortfolio(data[1]));
         ReduxStore.store.dispatch(ReduxStore.PortfolioFunctions.setSynthesisTemplates(data[2]));
         const views = data[3];
         const tabs = ['overview', 'about', 'discussion', 'evidence', 'addEvidence', 'resources', 'madness', 'mania', 'arpahSubmission', 'rules'];
         const initialTab = Utils.getParameterByName('initialTab', window.location.href);
         if (window.globals.idUser && tabs.includes(initialTab)) {
            this.tabChange(null, initialTab);
         }
         else if (!window.globals.idUser
            || (views && (views.length == 1 || views.length == 0))
            || (views.length > 1 && views[views.length - 2]['Time Viewed'] < this.props.portfolio.lastUpdateTime)
         ) {
            this.tabChange(null, 'overview');
         }
         else {
            this.tabChange(null, 'discussion');
         }
         this.setState({ isInitialized: true});
         gettingPageData = false;
      }, (err) => {
         if(err === 'You do not have access to this incubator'){
            openSignInDialog()
         }
         ToastAlert.error(err, null,  {
            "preventDuplicates": true,
            "preventOpenDuplicates": true,
         });
         gettingPageData = false;
      });
   }

   tabChange(event, value){
      history.pushState({ prevTab: this.state.value }, null, Utils.createUrlForPortfolioTab(value))
      if(value === 'madness'){
         this.props.hideSideBar();
      }
      this.setState({ value });
   };

   render() {
      if(!this.state.isInitialized){
        return(<LoadingScreen/>)
      }

      let notLoggedInIncubator = () => {
         if (!window.globals.idUser) {
            ToastAlert.error("Sign In or Register to get the most out of Polyplexus.");
            this.tabChange({}, 'overview');
            openSignInDialog();
         }
      }

      let hasIncubatorEditAccess = (idUser) => {
         return window.globals.isAdmin || idUser === this.props.portfolio.idOwner
            || (this.props.portfolio.owners && this.props.portfolio.owners.find(cur => cur.idUser === idUser));
      }

      let addCardToBracketFunction = async () => {
         try {
            await AjaxFunctions.addCardToBracket(this.props.portfolio.idBracket,this.props.portfolio.id, this.state.selectedIDCard, this.state.selectedCardType, this.state.category,this.state.selectedCardTitle, true);
            await AjaxFunctions.addCardToEndOfPortfolio(this.props.portfolio.id, this.state.selectedIDCard, this.state.selectedCardType,`Submission Reason: ${this.state.selectedCardReason}`);
            await AjaxFunctions.addCardToBracket(this.props.portfolio.idBracket,this.props.portfolio.id, this.state.selectedIDCard, this.state.selectedCardType, this.state.category, this.state.selectedCardTitle);
            this.props.getUpdatedPortfolioData(this.state.idPortfolio)
            this.setState({ key: this.state.key + 1, showAddCategoryDialog: false,selectedCardReason:'', selectedCardTitle:''});
            ToastAlert.success("Thank you for submitting. The bracket will be displayed at the end of the submission period.");
         }
         catch (err) {
            console.log(err)
            Toastr.error(err);
         }
      }

      let addCardToManiaFunction = async () => {
         try {
            await AjaxFunctions.addCardToMania(
               this.props.portfolio.idManiaTournament,
               this.props.portfolio.id,
               this.state.selectedIDCard,
               this.state.selectedCardType,
               this.state.category,
               this.state.selectedCardTitle,
               true
            );
            if(!this.props.portfolio.items.some(x => x.id === this.state.selectedIDCard && x.cardType === this.state.selectedCardType)) {
               await AjaxFunctions.addCardToEndOfPortfolio(
                  this.props.portfolio.id,
                  this.state.selectedIDCard,
                  this.state.selectedCardType,
                  `Submission Reason: ${this.state.selectedCardReason}`
               );
            }
            await AjaxFunctions.addCardToMania(
               this.props.portfolio.idManiaTournament,
               this.props.portfolio.id,
               this.state.selectedIDCard,
               this.state.selectedCardType,
               this.state.category,
               this.state.selectedCardTitle
            );
            this.props.getUpdatedPortfolioData(this.state.idPortfolio)
            this.setState({ key: this.state.key + 1, showSubmitManiaDialog: false, selectedCardReason:'', selectedCardTitle:''});
            ToastAlert.success("Thank you for submitting. The submission will be displayed at the end of the submission period.");
         }
         catch (err) {
            console.log(err)
            Toastr.error(err);
         }
      }

      let displayDateInFuture = moment(this.props.portfolio.displayTime).isAfter(new Date(),'day');
      let bracketStarted = this.props.portfolio.idBracket ? (this.props.portfolio.suggestionEndTime ?
         moment(this.props.portfolio.suggestionEndTime.toString().slice(0,10)).utcOffset("-05:00", true).endOf('day').isBefore(new Date()) : false) : true;
      let discussionType = this.props.portfolio.discussionType;

      let loggedInClass = window.globals.idUser ? 'logged-in' : 'not-logged-in';


      /* 
      If there's neither youtube nor zoom, 
      but there is discussion, show tab1. 
      If we have a zoom link and a youtube link, 
      show two tabs, and name them "Workshop 2" and "Workshop1"
      If there's only a zoom link, show tab2. 
      */
      let showDiscussionTab = (discussionType == SharedConstants.DiscussionType.Discussion || discussionType == SharedConstants.DiscussionType.Both);
      let discussionTabName =
         (this.props.portfolio.name === 'Dash to Accelerate Health Outcomes'
         || this.props.portfolio.name === 'Government-University-Industry-Philanthropy Research Roundtable')
            ? 'Questions?' : 'Forums';
      let discussionTabTooltip = 'Engage in discussion with this Incubator’s Sponsor and other Plexors.';
      let discussionTab2Name = discussionTabName;
      let showDiscussionTab2 = !!this.props.portfolio.zoomMeetingId;
      let youtubing = !!this.props.portfolio.videoLink;
      if (showDiscussionTab2) {
         if (!youtubing) {
            showDiscussionTab = false;
         } else {
            discussionTab2Name = "Workshop 2";
            discussionTabName = "Workshop 1";
            discussionTabTooltip = "Review discussions from past workshops";
         }
      }
      

      return (
         <div
            id='incubatorContainer'
            className={`page-container ${loggedInClass} ${this.props.portfolio.name.replaceAll(' ', '-')} ${this.props.portfolio.extraCssClass}`}
         >
            <div className='portfolio-list-page-header'>
            {this.props.portfolio.logoFile && 
               <div className="portfolio-list-page-header-banner"
                  style={{"backgroundColor": this.props.portfolio.bannerColor}}> 
                  <img
                     src={`${window.globals.USER_UPLOADS_BASE_URL}/incubators/${this.props.portfolio.id}/logo/${this.props.portfolio.logoFile}`}
                     alt='Incubator Logo'
                  />
               </div>
            }
               <h1 style={{color:`${this.props.portfolio.titleColor?this.props.portfolio.titleColor:'inherit'}`}}>{this.props.portfolio.name}</h1>
            </div>
            {hasIncubatorEditAccess(parseInt(window.globals.idUser)) &&
               <Button variant='outlined' color="primary" href={`/sponsor/editIncubator?id=${this.props.portfolio.id}`} style={{marginLeft: '16px'}}>Edit Workshop</Button>
            }
            {displayDateInFuture ? <div style={{marginLeft: '16px'}}> 
               {<Tabs
                  className='portfolio-list-page-tab-header'
                  value={this.state.value}
                  onChange={(event, value) => this.tabChange(event, value)}
                  indicatorColor="primary"
                  textColor="primary"
               >
                  <Tab className='portfolio-list-page-tab' value='overview' label={
                     <Tooltip title={tooltipTitle(
                        'Summarizes the purpose of this Incubator. ' +
                        'Earlier overview versions are also available so you can track the Sponsor’s thinking. ' +
                        'Scroll down to view important dates and PDFs to learn more about this research opportunity.'
                     )}>
                        <span>Read Me First</span>
                     </Tooltip>
                  } />
               </Tabs>}
               <br></br>
            </div> :
               <div>
                  {<Tabs
                     className='portfolio-list-page-tab-header'
                     value={this.state.value}
                     onChange={(event, value) => this.tabChange(event, value)}
                     indicatorColor="primary"
                     textColor="primary"
                  >
                     <Tab className='portfolio-list-page-tab' value='overview' label={
                        <Tooltip title={tooltipTitle(
                           'Summarizes the purpose of this Incubator. ' +
                           'Earlier overview versions are also available so you can track the Sponsor’s thinking. ' +
                           'Scroll down to view important dates and PDFs to learn more about this research opportunity.'
                        )}>
                           <span>Read Me First</span>
                        </Tooltip>
                     } />
                     {
                        (this.props.portfolio.sponsorBio && this.props.portfolio.sponsorDisplayName) &&
                        <Tab className='portfolio-list-page-tab' value='about' label={`ABOUT ${this.props.portfolio.sponsorDisplayName}`} />
                     }
                     {
                        (this.props.portfolio.name === 'Dash to Accelerate Health Outcomes') &&
                        <Tab
                           className={'portfolio-list-page-tab rules-tab ' + loggedInClass}
                           value='rules'
                           label={`Rules`}
                        />
                     }
                     {
                        (this.props.portfolio.name === 'Dash to Accelerate Health Outcomes') &&
                        <Tab
                           className={'portfolio-list-page-tab entry-form-tab ' + loggedInClass}
                           value='arpahSubmission'
                           label={`Entry Form`}
                        />
                     }

                    {
                       (discussionType == SharedConstants.DiscussionType.QuestionAnswer
                        || discussionType == SharedConstants.DiscussionType.Both) &&
                       <Tab className='portfolio-list-page-tab' value='question' label={`Q & A`} />
                    }

                    {
                       (true || bracketStarted) &&
                       <Tab
                          className={'portfolio-list-page-tab incubator-pubs-tab ' + loggedInClass}
                          value='evidence'
                          label={
                              <Tooltip
                                 title={tooltipTitle(
                                    'Submit Evidence or Conjecture µPubs created by you or your fellow Plexors here. ' +
                                    'The Sponsor will review your submissions and may elect to both publish and promote them to ' +
                                    'indicate interest in a particular line of thinking.'
                                 )}
                              >
                              <span style={{ textTransform: 'none' }}>
                                 {
                                    this.props.portfolio.name === 'Dash to Accelerate Health Outcomes' ?
                                       'EVIDENCE' :
                                       `WORKSHOP ${String.fromCharCode(181)}PUBS`
                                 }
                              </span>
                              </Tooltip>
                           }
                       />}
                     {
                        (!this.props.portfolio.idMania || window.globals.isSponsor ) &&
                        !this.props.portfolio.idBracket &&
                           <Tab
                              className='portfolio-list-page-tab add-evidence-tab'
                              value='addEvidence'
                              label={`SEARCH & ADD ${String.fromCharCode(181)}PUBS`}
                              style={{ textTransform: 'none' }}
                           />
                     }
                     {
                        this.props.portfolio.idBracket &&
                        <Tab
                           className={'portfolio-list-page-tab bracket-tab ' + loggedInClass}
                           value='madness'
                           label={`Brackets`}
                        />
                     }
                     {this.props.portfolio.idMania && <Tab className='portfolio-list-page-tab' value='mania' label={`MANIA`} />}
                     {
                        !this.props.portfolio.idMania && (this.props.portfolio.name !== 'Dash to Accelerate Health Outcomes') &&
                        <Tab
                           className='portfolio-list-page-tab resources'
                           value='resources'
                           label={this.props.portfolio.idBracket?`RULES`:'RESOURCES'}
                        />
                     }
                     {false && <Tab className='portfolio-list-page-tab' value='graph' label={'GRAPH'} />}
                     {
                        (showDiscussionTab2) &&
                        <Tab
                           className={'portfolio-list-page-tab discussion-tab ' + loggedInClass}
                           value='webinar'
                           label={
                              <Tooltip title={tooltipTitle(
                                 'Engage in discussion with this Incubator’s Sponsor and other Plexors.'
                              )}>
                                 <span>
                                    {discussionTab2Name}
                                 </span>
                              </Tooltip>
                           }
                        />
                     }
                     {
                        (showDiscussionTab) &&
                        <Tab
                           className={'portfolio-list-page-tab discussion-tab ' + loggedInClass}
                           value='discussion'
                           label={
                              <Tooltip title={tooltipTitle(discussionTabTooltip)}>
                                 <span>
                                    {discussionTabName}
                                 </span>
                              </Tooltip>
                           }
                        />
                     }
                  </Tabs>}
                  <br></br>
               </div>}
            {
               (this.state.value === 'overview') &&
               <OverviewTab
                  descriptions={this.props.portfolio.descriptions}
                  attachments={this.props.portfolio.attachments}
                  portfolio={this.props.portfolio}
                  sponsorDisplayName={this.props.portfolio.sponsorDisplayName}
                  isActive={this.props.portfolio.isActive}
               />
            }
            {(this.state.value === 'about') &&
              ( window.globals.idUser ?
                 <AboutTab
                   sponsorBio={this.props.portfolio.sponsorBio}
                   sponsorDisplayName={this.props.portfolio.sponsorDisplayName}
                />: notLoggedInIncubator())
            }
            {
               (this.state.value === 'webinar') &&
               (
                  (window.globals.idUser) ?
                     <PortfolioDiscussionTab
                        tabChange={tab => this.tabChange(undefined, tab)}
                        secondaryOwners = {this.props.portfolio.owners.map((owner) => owner.idUser)}
                        portfolio= {this.props.portfolio}
                        getUpdatedPortfolioData={() => this.props.getUpdatedPortfolioData(this.state.idPortfolio)}
                        hideRemovalLogs={true}
                        videoSource={'zoom'}
                    />: notLoggedInIncubator()
               )
             }
            {
               (this.state.value === 'discussion') &&
               (
                  (window.globals.idUser || this.props.portfolio.name === 'Dash to Accelerate Health Outcomes') ?
                     <PortfolioDiscussionTab
                        tabChange={tab => this.tabChange(undefined, tab)}
                        secondaryOwners = {this.props.portfolio.owners.map((owner) => owner.idUser)}
                        portfolio= {this.props.portfolio}
                        getUpdatedPortfolioData={() => this.props.getUpdatedPortfolioData(this.state.idPortfolio)}
                        hideRemovalLogs={true}
                        videoSource={youtubing ? 'youtube' : null}
                    />: notLoggedInIncubator()
               )
             }
             {(this.state.value === 'question' && (discussionType == SharedConstants.DiscussionType.QuestionAnswer || discussionType == SharedConstants.DiscussionType.Both)) &&
               (window.globals.idUser ?
                  <QuestionTab
                     getUpdatedPortfolioData={() => this.props.getUpdatedPortfolioData(this.state.idPortfolio)}
                     items={this.props.portfolio.items.filter((item) => item.cardType === SharedConstants.CardType.Question)}
                     tab={this.state.value}
                  /> : notLoggedInIncubator()
               )
            }
            {this.state.value === 'evidence' &&
    (           window.globals.idUser ? <EvidenceTab
                  idMania={this.props.portfolio.idMania}
                  idPortfolio={this.props.portfolio.id}
                  linkFunction={cardData => this.props.cardLinkFunction(cardData)}
                  tab={this.state.value}
               />: notLoggedInIncubator())
            }
            {this.state.value === 'addEvidence' &&
               (window.globals.idUser ?
                  <IncubatorAddCardTab
                     portfolio={this.props.portfolio}
                     lastFilterFunction={this.props.lastFilterFunction}
                     getUpdatedPortfolioData={() => this.props.getUpdatedPortfolioData(this.state.idPortfolio)}
                     setLastFilterFunction={func => this.props.setLastFilterFunction(func)}
                     linkFunction={cardData => this.props.cardLinkFunction(cardData)}
                     cards={this.props.filteredCardList}
                     tab={this.state.value}
                  />
               : notLoggedInIncubator())
            }
            {(this.state.value === 'resources') &&
               ( window.globals.idUser ?
                  <ResourcesTab
                     resources={this.props.portfolio.resources}
                     instructions={this.props.portfolio.instructions}
                     title={this.props.portfolio.idBracket?`RULES`:'RESOURCES'}
                  />: notLoggedInIncubator())
            }

            {(this.state.value === 'madness') &&
              ( window.globals.idUser ?
               <Bracket
                  key={this.state.key}
                  lastFilterFunction={this.props.lastFilterFunction}
                  setLastFilterFunction={(func) => this.props.setLastFilterFunction(func)}
                  idPortfolio={this.props.portfolio.id}
                  allTopics={this.props.allTopics}
                  addCardFunction={(idCard, cardType) => this.setState({
                     showAddCategoryDialog:true,
                     selectedIDCard:idCard,
                     selectedCardType:cardType
                  })}
                  tab={this.state.value}
                  getUpdatedPortfolioData={() => this.props.getUpdatedPortfolioData(this.state.idPortfolio)}
                  createCardFunction={(idCard) => this.setState({
                     showAddCategoryDialog:true,
                     selectedIDCard:idCard,
                     selectedCardType: SharedConstants.CardType.Evidence
                  })}
                  portfolio={this.props.portfolio}
                  onBackButton={() => this.tabChange(null, 'overview')}
               /> : notLoggedInIncubator())
            }
            {
               (this.state.value === 'mania') &&
               (
                  window.globals.idUser ?
                  <Mania
                     key={this.state.key}
                     lastFilterFunction={this.props.lastFilterFunction}
                     setLastFilterFunction={(func) => this.props.setLastFilterFunction(func)}
                     idPortfolio={this.props.portfolio.id}
                     allTopics={this.props.allTopics}
                     addCardFunction={(idCard) => this.setState({
                        showSubmitManiaDialog:true,
                        selectedIDCard:idCard,
                        selectedCardType:SharedConstants.CardType.Reasoning
                     })}
                     tab={this.state.value}
                     getUpdatedPortfolioData={() => this.props.getUpdatedPortfolioData(this.state.idPortfolio)}
                     createCardFunction={(idCard) => this.setState({
                        showSubmitManiaDialog:true,
                        selectedIDCard:idCard,
                        selectedCardType: SharedConstants.CardType.Reasoning
                     })}
                     portfolio={this.props.portfolio}
                  /> : notLoggedInIncubator()
               )
            }
            {
               this.state.value === 'graph' &&
               (
                  window.globals.idUser ?
                  <GraphTab
                     portfolio={this.props.portfolio}
                     lastFilterFunction={this.props.lastFilterFunction}
                     getUpdatedPortfolioData={() => this.props.getUpdatedPortfolioData(this.state.idPortfolio)}
                     setLastFilterFunction={func => this.props.setLastFilterFunction(func)}
                     linkFunction={cardData => this.props.cardLinkFunction(cardData)}
                     cards={this.props.filteredCardList}
                     tab={this.state.value}
                  />
                  : notLoggedInIncubator()
               )
            }
            {
               this.state.value === 'rules' &&
               <RulesTab />
            }
            {
               this.state.value === 'arpahSubmission' &&
               (
                  window.globals.idUser ?
                     <ArpahSubmissionTab
                        getUpdatedPortfolioData={() => this.props.getUpdatedPortfolioData(this.state.idPortfolio)}
                        idPortfolio={this.props.portfolio.id}
                     />
                     : notLoggedInIncubator()
               )
            }
            <CardModal
               returnUrl='/incubator'
               searchUrl={`?idIncubator=${this.props.portfolio.id}&initialTab=${this.state.value}`}
               currentPortfolio={this.props.portfolio.id}
               showComments={true}
            />
            <BracketSubmitDialog
               open={this.state.showAddCategoryDialog}
               selectedCardTitle={this.state.selectedCardTitle}
               onTitleChanged={(e) => this.setState({selectedCardTitle: e.target.value.substring(0,15)})}
               category={this.state.category}
               categoryOnChange={(e) =>this.setState({category: e.target.value}) }
               selectedCardReason={this.state.selectedCardReason}
               onSelectedCardReasonChanged={(e) => this.setState({selectedCardReason: e.target.value})}
               onSubmit={() => addCardToBracketFunction()}
               onCancel={() => this.setState({showAddCategoryDialog:false})}
            />
            <ManiaSubmitDialog
               open={this.state.showSubmitManiaDialog}
               selectedCardTitle={this.state.selectedCardTitle}
               onTitleChanged={(e) => this.setState({selectedCardTitle: e.target.value.substring(0,15)})}
               selectedCardReason={this.state.selectedCardReason}
               onSelectedCardReasonChanged={(e) => this.setState({selectedCardReason: e.target.value})}
               onSubmit={() => addCardToManiaFunction()}
               onCancel={() => this.setState({showSubmitManiaDialog:false})}
            />

         </div>
      );
   }
}

const mapListViewStateToProps = (state) => {
   let filteredCardList = state.CardReducer.cardList;
   return {
      portfolio: new SharedModels.Incubator(state.PortfolioReducer.curPortfolio),
      filteredCardList,
   }
};

const mapListViewDispatchToProps = (dispatch) => {
   return {
      getUpdatedPortfolioData: async (idPortfolio) => {
         let portfolioData = await AjaxFunctions.getUserPortfolios();
         dispatch(ReduxStore.PortfolioFunctions.setPortfolioList(portfolioData));
         let curPortfolioData = await AjaxFunctions.getIncubatorById(idPortfolio);
         dispatch(ReduxStore.PortfolioFunctions.setCurPortfolio(curPortfolioData));
      },
      cardLinkFunction: (cardData) => {
         if(cardData.cardType === SharedConstants.CardType.Evidence) {
            dispatch(ReduxStore.EvidenceCardFunctions.setCurrentCard(cardData));
         }
         else if(cardData.cardType === SharedConstants.CardType.Reasoning)
            dispatch(ReduxStore.GreySpaceCardFunctions.setCurrentCard(cardData));
      },
      resetCardData: (cardType) => {
         if(cardType === SharedConstants.CardType.Evidence) {
            dispatch(ReduxStore.EvidenceCardFunctions.setCurrentCard(new SharedModels.EvidenceCard({})));
         }
         else if(cardType === SharedConstants.CardType.Reasoning)
            dispatch(ReduxStore.GreySpaceCardFunctions.setCurrentCard(new SharedModels.GreySpaceCard({})));
      },
   }
};

export default connect(
   mapListViewStateToProps,
   mapListViewDispatchToProps
)(PortfolioBase);
